export default "__VITE_ASSET__gGVyKAsc__"